import { useContext, useEffect, useState } from "react";
import { Table, Tooltip, Card, Select } from "antd";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

const { Column } = Table;
const { Option } = Select;

const ViewsReports = () => {
  const { token, apiUrl } = useContext(Context);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState([]);
  const [timeframe, setTimeframe] = useState("24:hours");

  useEffect(() => {
    setLoading(true);
    Fetch(
      `${apiUrl}/reports/content_views?timeframe=${timeframe}`,
      token,
      (result) => {
        if (result) {
          setData(result.data);
          setRefresh(false);
          setLoading(false);
        }
      }
    );
  }, [apiUrl, token, refresh, timeframe]);

  return (
    <div>
      <Card
        title="Views Report"
        extra={
          <div>
            <Select
              style={{ width: "150px" }}
              onChange={setTimeframe}
              defaultValue={timeframe}
            >
              <Option value="60:minutes">Last 60 minutes</Option>
              <Option value="6:hours">Last 6 hours</Option>
              <Option value="24:hours">Last 24 hours</Option>
              <Option value="3:days">Last 3 days</Option>
              <Option value="7:days">Last 7 days</Option>
              <Option value="30:days">Last 30 days</Option>
              <Option value="all">Till Date</Option>
            </Select>
          </div>
        }
      >
        <Table dataSource={data} loading={loading} size="small">
          <Column
            title="Content Title"
            align="left"
            dataIndex={"title"}
            render={(_, record) =>
              record.title.length > 50 ? (
                <Tooltip title={record.title}>
                  <span>{`${record.title.slice(0, 50)}...`}</span>
                </Tooltip>
              ) : (
                record.title
              )
            }
          />
          <Column title="Views" align="center" dataIndex={"views"} />
        </Table>
      </Card>
    </div>
  );
};

export default ViewsReports;
